import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Paper } from './Paper';
import { StyledPaperLayout } from './paperLayoutStyle';
import { setWaveformViewIndex } from '../../../../../actions/WaveformActions';
import { Brush } from './Brush';
import {
    calculateSizeAndPositionOnParent,
    canvasPositionsAndSizes,
} from '../../../../../util/ECG';
import { useSize } from '../../../../../util/useSize';

export const PaperLayout = ({ fetchECGData }) => {
    const dispatch = useDispatch();
    const [refSize, papersParentSize] = useSize();
    const [scroll, setScroll] = useState(0);

    const { waveformLayout, waveformLayoutViewIndex } = useSelector(
        (state) => state.waveform,
    );

    return !papersParentSize ? (
      <StyledPaperLayout ref={refSize} />
    ) : (
      <StyledPaperLayout ref={refSize}>
        {waveformLayout.obj.map((item, index) => (fetchECGData.sequences[0][item] ? (
          <Paper
            selected={index === waveformLayoutViewIndex}
            divSize={calculateSizeAndPositionOnParent(
              canvasPositionsAndSizes(
                papersParentSize,
                waveformLayout.name,
                index,
              ),
            )}
            scroll={index === 12 ? undefined : scroll}
            dispatchSelected={() => dispatch(setWaveformViewIndex(index))}
            channel={fetchECGData.sequences[0][item]}
            key={`${index.toString() + item.toString()}key`}
            index={index}
            layoutName={waveformLayout.name}
          />
          ) : null),)}
        {waveformLayout.name === 'twelvePlusOne' && (
          <Brush divSize={papersParentSize} onScroll={(x) => setScroll(x)} />
          )}
      </StyledPaperLayout>
    );
};

export default PaperLayout;
